export default __webpack_public_path__ + "static/media/model_x.83417303.jpeg";